export const aiReasons = [
    {
        title: "High-Paying Jobs",
        description: (
            <>
                AI professionals are in demand across industries, with many
                roles offering{" "}
                <span className="highlight">
                    strong career growth and competitive salaries
                </span>
                .
            </>
        ),
    },

    {
        title: "Massive Job Opportunities",
        description: (
            <>
                AI skills are opening opportunities in{" "}
                <span className="highlight-blue">
                    software, healthcare, finance, automotive, manufacturing
                </span>
                , cybersecurity, and many other industries.
            </>
        ),
    },

    {
        title: "Smart Career Move",
        description: (
            <>
                Learning AI helps you build skills around technologies that
                are increasingly being used to{" "}
                <span className="highlight">
                    automate and improve real-world applications
                </span>
                .
            </>
        ),
    },

    {
        title: "Fast Career Growth",
        description: (
            <>
                AI combines{" "}
                <span className="tech-tag">Programming</span>
                <span className="tech-tag">Data</span>
                <span className="tech-tag">Machine Learning</span>
                <span className="tech-tag">Problem Solving</span>
                {" "}skills, creating multiple paths for professional growth.
            </>
        ),
    },

    {
        title: "Global Demand",
        description: (
            <>
                Organizations around the world are adopting AI technologies
                and looking for professionals who can{" "}
                <span className="highlight-blue">
                    build and integrate AI solutions
                </span>
                .
            </>
        ),
    },

    {
        title: "Huge Talent Shortage",
        description: (
            <>
                The rapid adoption of AI has increased demand for
                professionals with practical skills in{" "}
                <span className="tech-tag">AI</span>
                <span className="tech-tag">Machine Learning</span>
                <span className="tech-tag">Generative AI</span>
                .
            </>
        ),
    },

    {
        title: "Work on Cutting-Edge Tech",
        description: (
            <>
                Build practical solutions using{" "}
                <span className="tech-tag">Machine Learning</span>
                <span className="tech-tag">Deep Learning</span>
                <span className="tech-tag">NLP</span>
                <span className="tech-tag">Computer Vision</span>
                <span className="tech-tag">Generative AI</span>
                <span className="tech-tag">LLMs</span>
                .
            </>
        ),
    },

    {
        title: "Career Switch Friendly",
        description: (
            <>
                AI can be a career transition path for{" "}
                <span className="highlight">
                    developers, testers, data professionals, engineers
                </span>
                , and other technology professionals.
            </>
        ),
    },

    {
        title: "India's AI Market Is Booming",
        description: (
            <>
                India is seeing increasing adoption of AI across{" "}
                <span className="highlight-blue">
                    startups, IT services, enterprises, manufacturing and
                    healthcare
                </span>
                .
            </>
        ),
    },

    {
        title: "Future-Proof Your Career",
        description: (
            <>
                Developing AI skills can help you stay relevant as
                organizations continue integrating{" "}
                <span className="highlight">
                    intelligent and automated technologies
                </span>
                .
            </>
        ),
    },
];